import {TwColorUnionType}  from '../../ui/ui.types';
import {OuraReadinessIntf} from './oura-ready.types';


export type ResultDataIntf = {
	awakeMinutes: number,
	asleepMinutes: number
}
export type ResultData = {
	[key: string]: ResultDataIntf
}

export interface IncrementStringIntf<T> {
	value: T;
	timestamp: Date;
}

export type MovementType =
	| 1 // no motion,
	| 2 // restless,
	| 3 // tossing and turning
	| 4 // active

export type SleepType =
	| 'long_sleep'
	| 'deleted'
	| 'sleep'
	| 'late_nap'

export type SleepTypeDict<T> = {
	[key in SleepType]: T
}

export type SleepTypeDictData = {
	name: string;
}

export const SleepTypesDict: SleepTypeDict<SleepTypeDictData> = {
	deleted   : {
		name: 'Deleted'
	},
	late_nap  : {
		name: 'Late Nap'
	},
	long_sleep: {
		name: 'Long Sleep'
	},
	sleep     : {
		name: 'Sleep'
	}

}

export interface OuraSleepKeyIntf {
	[key: string]: OuraSleepIntf;
}

export type SleepPhaseType =
	| 1
	| 2
	| 3
	| 4


/*
 export enum SleepPhaseEnum {
 '1' = 'deep sleep,',
 '2' = 'light sleep,',
 '3' = 'REM sleep',
 '4' = ' awake.',
 }
 */

export enum SleepPhaseColorEnum {
	Phase1 = 'deep sleep,',
	Phase2 = 'light sleep',
	Phase3 = 'REM sleep',
	Phase4 = ' awake.',
}

export type SleepPhaseDict<T> = {
	[key in SleepPhaseType]: T
}

export const SleepPhaseColorDict: SleepPhaseDict<TwColorUnionType> = {
	1: 'blue',
	2: 'indigo',
	3: 'violet',
	4: 'purple'
};
export const SleepPhaseLabelDict: SleepPhaseDict<string> = {
	1: 'Deep',
	2: 'Light',
	3: 'REM',
	4: 'Awake'
};

export interface SleepPhaseIntf {
	value: SleepPhaseType;
	timestamp: Date;
}

export interface OuraHeartIntervalIntf {
	interval: number;
	items: number[],
	timestamp: Date;
}

export interface OuraSleepReportIntf {
	average_breath: number;
	average_heart_rate: number;
	average_hrv: number;
	awake_time: number;
	bedtime_end: string;
	bedtime_start: string;
	deep_sleep_duration: number;
	efficiency: number;
	latency: number;
	light_sleep_duration: number;
	lowest_heart_rate: number;
	rem_sleep_duration: number;
	time_in_bed: number;
	total_sleep_duration: number;
	type: SleepType;
}

export interface OuraSleepIntf {
	adjustedBedtimeStart: Date;
	nextBedtimeStart?: Date;
	nextBedtimeEnd?: Date;

	average_breath: number;
	average_heart_rate: number;
	average_hrv: number;
	awake_time: number;
	bedtime_end: Date;
	bedtime_start: Date;
	day: Date;
	deep_sleep_duration: number;
	efficiency: number;
	heart_rate: OuraHeartIntervalIntf;
	hrv: OuraHeartIntervalIntf;
	id: string;
	latency: number;
	light_sleep_duration: number;
	low_battery_alert: false;
	lowest_heart_rate: number;
	movement_30_sec: IncrementStringIntf<MovementType>[];
	period: number;
	readiness: OuraReadinessIntf;
	readiness_score_delta: number;
	rem_sleep_duration: number;
	restless_periods: number;
	sleep_algorithm_version: string;
	sleep_phase_5_min: SleepPhaseIntf[];
	sleep_score_delta: number;
	time_in_bed: number;
	total_sleep_duration: number;
	type: SleepType;
}